/* businesses */
export const GET_SUPPORT_MATERIAL_TYPE = "GET_SUPPORT_MATERIAL_TYPE"
export const GET_SUPPORT_MATERIAL_TYPE_SUCCESS =
  "GET_SUPPORT_MATERIAL_TYPE_SUCCESS"
export const GET_SUPPORT_MATERIAL_TYPE_CLEAN = "GET_SUPPORT_MATERIAL_TYPE_CLEAN"
export const GET_SUPPORT_MATERIAL_TYPE_ERROR = "GET_SUPPORT_MATERIAL_TYPE_ERROR"
